import { t, Instance } from 'mobx-state-tree';

/**
 * User Model - Minimal data structure for authenticated user
 * Following pantryPlus pattern
 */
export const UserModel = t
  .model('UserModel', {
    id: t.identifier,
    personId: t.maybeNull(t.string),
    email: t.string,
    nickname: t.string,
    createdAt: t.optional(t.string, ''),
    allowedToCreateFamily: t.optional(t.boolean, false)
  })
  .views((self) => ({
    get displayName(): string {
      return self.nickname || self.email;
    }
  }));

export type UserType = Instance<typeof UserModel>;
